import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={59}
    height={58}
    viewBox="0 0 59 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.2} cx={29.5} cy={29} r={29} fill="#00A692" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7277 14.5003H22.7322L14.401 38.6667H11.375L21.7268 14.5003H21.7277ZM28.7782 19.0751H30.7467L30.9178 22.9914H28.6069L28.778 19.0751H28.7782ZM28.373 24.951H31.1279L31.2807 30.7106H28.1246L28.3728 24.951H28.373ZM24.4711 14.5H28.8799L28.7555 17.7657H30.7703L30.6453 14.5H34.9899L42.6096 38.6663H31.8502L31.4978 33.441H28.0092L27.7038 38.6663H16.9133L24.4724 14.5H24.4711ZM36.7292 14.5H37.9407L47.625 38.6663H45.1225L36.7287 14.5H36.7292Z"
      fill="#636F7C"
    />
  </svg>
);
export default SVGComponent;
